<template>
  <div class="recruitmentList_container">
    <div class="image">
      <img
        v-if="recruitmentType === '社会招聘'"
        src="../assets/image/jinyafu1.jpg"
      />
      <img v-else src="../assets/image/jinyafu2.jpg" />
    </div>
    <div class="card_wrapper">
      <div class="card">
        <div class="nav">
          <i class="el-icon-s-home"></i>
          {{ recruitmentType }} > 职位列表
        </div>
        <div class="filter">
          <el-input
            placeholder="请输入内容"
            v-model="position"
            @keyup.enter.native="handQuery"
          >
            <template slot="prepend">{{ recruitmentType }}</template>
            <el-button slot="append" icon="el-icon-search" @click="handQuery">
              职位搜索
            </el-button>
          </el-input>
        </div>
        <div class="tabledata">
          <el-table
            :data="tableData"
            style="width: 100%"
            :header-cell-style="{ background: '#f4f4f4', color: '#333333' }"
          >
            <el-table-column prop="position" label="职位名称">
              <template slot-scope="scope">
                <div @click="goDetail(scope.row)">{{ scope.row.position }}</div>
              </template>
            </el-table-column>
            <el-table-column prop="count" label="招聘人数">
              <template slot-scope="scope">
                <div @click="goDetail(scope.row)">{{ scope.row.count }}</div>
              </template>
            </el-table-column>
            <el-table-column prop="company" label="所属机构">
              <template slot-scope="{ row }">
                <div v-if="companyTextMap[row.company]" @click="goDetail(row)">
                  {{ companyTextMap[row.company] }}
                </div>
              </template>
            </el-table-column>
            <!-- <el-table-column prop="jobCategory" label="职位类别">
              <template slot-scope="scope">
                <div @click="goDetail(scope.row)">
                  <span v-if="scope.row.jobCategory == 1">人力资源类</span>
                  <span v-else-if="scope.row.jobCategory == 2">信息技术类</span>
                  <span v-else-if="scope.row.jobCategory == 3">财务管理类</span>
                  <span v-else-if="scope.row.jobCategory == 4">行政管理类</span>
                  <span v-else-if="scope.row.jobCategory == 5">品牌策划类</span>
                  <span v-else-if="scope.row.jobCategory == 6">风险交易类</span>
                  <span v-else-if="scope.row.jobCategory == 7">战略管理类</span>
                  <span v-else-if="scope.row.jobCategory == 8">产业项目类</span>
                  <span v-else-if="scope.row.jobCategory == 9">投融管理类</span>
                  <span v-else-if="scope.row.jobCategory == 10"
                    >集团办公室类</span
                  >
                  <span v-else-if="scope.row.jobCategory == 11"
                    >市场运营类</span
                  >
                  <span v-else>无类别</span>
                </div>
              </template>
            </el-table-column> -->
            <el-table-column prop="workPlace" label="工作地点">
              <template slot-scope="{ row }">
                <div @click="goDetail(row)">
                  {{ row.workPlace || '' }}
                </div>
              </template>
            </el-table-column>
          </el-table>
        </div>
        <div class="pagination">
          <el-pagination
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page="currentPage"
            :page-sizes="[10, 20, 30, 40, 50]"
            :page-size="pageSize"
            layout="total, sizes, prev, pager, next"
            :total="DataTotal"
          >
          </el-pagination>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import axios from 'axios';
import { companyTextMap } from '@/maps/company';

export default {
  name: 'recruitmentList',
  data() {
    return {
      recruitmentType: '',
      recruitmentCode: 0,
      tableData: [],
      currentPage: 1,
      pageSize: 10,
      DataTotal: 0,
      position: '',
      companyTextMap,
    };
  },
  created() {
    // var that = this;
    this.recruitmentCode = this.$route.query.type;
    this.recruitmentType =
      this.$route.query.type == 1 ? '校园招聘' : '社会招聘';
    this.queryTableData(this.recruitmentCode); //列表初始加载
  },
  methods: {
    //去详情页
    goDetail(val) {
      this.$router.push({
        name: 'recruitmentDetail',
        query: {
          id: val.id,
        },
      });
    },
    //手动搜索
    handQuery() {
      this.currentPage = 1;
      this.pageSize = 10;
      this.queryTableData(this.recruitmentCode);
    },
    // 切换条数
    handleSizeChange(val) {
      this.pageSize = val;
      this.queryTableData(this.recruitmentCode);
    },
    // 切换当前页
    handleCurrentChange(val) {
      this.currentPage = val;
      this.queryTableData(this.recruitmentCode);
    },
    // 招聘数据请求
    queryTableData(params) {
      // console.log(params, 'params');
      axios
        .post('/api/recruit/list', {
          body: {
            recruitQuery: {
              position: this.position,
              recruitType: params,
            },
            page: {
              pageSize: this.pageSize,
              pageNumber: this.currentPage,
            },
          },
        })
        .then(res => {
          if (res.data.body.list.length) {
            this.tableData = res.data.body.list;
            this.pageSize = res.data.body.page.pageSize;
            this.currentPage = res.data.body.page.pageNumber;
            this.DataTotal = res.data.body.page.totalCount;
          }
        })
        .catch(error => {
          console.log(error);
        });
    },
  },
  beforeRouteUpdate(to, from, next) {
    this.recruitmentCode = to.query.type;
    this.recruitmentType = to.query.type == 1 ? '校园招聘' : '社会招聘';
    if (to.query.type != from.query.type) {
      this.queryTableData(this.recruitmentCode);
      next();
    }
  },
};
</script>
<style lang="scss">
.recruitmentList_container {
  text-align: left;
  .image {
    img {
      width: 100%;
    }
  }
  .card_wrapper {
    margin: 20px 0 20px;
    display: flex;
    justify-content: center;
    .card {
      width: 800px;
      padding: 20px;
      background: #fff;
      .filter {
        margin-top: 30px;
      }
      .tabledata {
        margin-top: 30px;
        .el-table {
          .el-table__row > td {
            border: none;
          }
          .el-table::before {
            //去掉最下面的那一条线
            height: 0px;
          }
          .el-table__header tr,
          .el-table__header th {
            padding: 0;
            height: 40px;
          }
          .el-table__body tr,
          .el-table__body td {
            padding: 0;
            height: 50px;
          }
          .el-table__body {
            cursor: pointer;
          }
        }
      }
      .pagination {
        display: flex;
        justify-content: center;
        margin-top: 30px;
      }
    }
  }
}
</style>
